import type { ThemeOptions } from '@mui/material/styles';

export function getTypography(): Pick<ThemeOptions, 'typography'> {
    return {
        typography: {
            fontFamily: 'Lato, sans-serif',
        },
    };
}
